// extracted by mini-css-extract-plugin
module.exports = {"current-price":"EditPrice_current-price__21WTR","price-info":"EditPrice_price-info__3oZaZ","price-value":"EditPrice_price-value__17mqF","buttons":"EditPrice_buttons__18PoE"};